module.exports = __webpack_public_path__ + "img/paso4.5bbc2313.png";